import { Navigate, } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LOGIN_PATH } from '../appConstants';

const RootRoute = () => {
    const auth = useSelector((state) => state.auth, (prevAuth, nextAuth) => {
        return nextAuth;
    });

    if (auth?.isAuthenticated) {
        if (auth.role === 'admin') {
            return <Navigate to="admin/dashboard" replace />;
        } else if (auth.role === 'clinician') {
            return <Navigate to="clinician/dashboard" replace />;
        } else if (auth.role === 'facility') {
            return <Navigate to="facility/dashboard" replace />;
        }
    }

    return <Navigate to={LOGIN_PATH} replace />;
};

export default RootRoute;